<template>
  <div class="page">
    <div class="top">
      <div class="box">
        <div class="bg">
          <img src="./assets/fengxian/bg@2x.png" alt="" />
          <div class="avator">
            <img
              src="http://fimage.oss-cn-shenzhen.aliyuncs.com/upload/image/20200819/1597804586458052529.jpeg"
              alt=""
            />
          </div>
          <div class="title">我是您的希望保专属风险顾问</div>
          <div class="tip">1对1定制服务</div>

          <div class="info">
            <div class="info-tip tip1">点击下方电话</div>
            <div class="info-tip tip2">免费咨询服务</div>
            <!-- <div class="ewm">
              <img src="./assets/fengxian/erwm@2x.png" alt="" />
            </div> -->
            <div class="phone" v-if="data">
              <div class="name" >{{ data.name }}</div>
              <!-- <span @click="call()">{{data.mobile}}</span> -->
              <a :href="'tel://' + data.mobile">{{data.mobile}}</a>
            </div>
          </div>

          <div class="slogan">企业/机构/组织者等专属保险方案</div>
        </div>
      </div>
    </div>
    <div class="slogan-tip">一个为企业降低风险的平台</div>
  </div>
</template>

<script>
import storejs from "store";
import util from "@/libs/util.js";
import moment from "moment";
import { Dialog, Field, Checkbox, CheckboxGroup, Button, Toast } from "vant";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";
var wx = require("weixin-js-sdk");

export default {
  name: "Mine",
  components: {
    Dialog,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Toast.name]: Toast,
  },
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData"),
      pageHeight: window.innerHeight,
      data: {},
      price: "",
      vxChecked: true,
      baseInfo: {},
      unionId: "",
      openId: "",
    };
  },
  watch: {},
  async mounted() {
    if(this.$page.isInWechat){
      wechatService.auth(
        0,
        ({ openid, unionid }) => {
          if (!!openid && !!unionid) {
            console.log("openId", openid);
            this.unionId = unionid;
            this.openId = openid;
          }
        },
        true
      );
    }
    await this.getMySales();
  },
  beforeDestroy: function () {},
  methods: {
    async getMySales() {
      let res = await this.$http.post("/api/accountLogin/getMySales", {
        accountId: this.publicData.id
      });
      if (!res.code) {
        console.log("res", res);
        this.data = res.t;
      }
    },
    call() {
      wx.miniProgram.navigateTo({
        url:
          "/pages/tel/tel?iid=0" +
          "&mobile=" +
          encodeURIComponent(`${this.data.mobile}`) +
          "&from=1",
        success: function () {
          // window.history.go(-1);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  position: relative;
  min-height: 100%;
  .top {
    background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);
    width: 100%;
    height: 2.5rem;
    // padding: 0 0.13rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    box-sizing: border-box;
    .box {
      width: 100%;
      position: relative;
      height: 2rem;
      .bg {
        width: 100%;
        position: relative;
        height: 5rem;
        img {
          width: 100%;
          position: absolute;
          top: 0;
          height: 5rem;
        }
      }
      // background: url('./assets/fengxian/bg@2x.png') no-repeat;
      .avator {
        width: 0.74rem;
        height: 0.74rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 50%;
        top: 0.1rem;
        transform: translateX(-50%);
        img {
          width: 0.74rem;
          height: 0.74rem;
          border-radius: 50%;
          position: relative;
        }
      }
      .title {
        font-size: 0.18rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        position: absolute;
        left: 50%;
        top: 1.1rem;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: translateX(-50%);
      }
      .tip {
        font-size: 0.18rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        position: absolute;
        left: 50%;
        top: 1.4rem;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: translateX(-50%);
      }
      .info {
        width: 1.63rem;
        position: absolute;
        left: 50%;
        top: 2rem;
        transform: translateX(-50%);
        .info-tip {
          font-size: 0.15rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          text-align: center;
          margin-bottom: 0.1rem;
        }
        .ewm {
          width: 100%;
          height: 1.4em;
          display: flex;
          position: relative;
          img {
            width: 1.4rem;
            height: 1.4em;
            position: relative;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .phone {
          display: flex;
          align-items: center;
          height: 1rem;
          justify-content: center;
          flex-direction: column;
          div {
            font-size: 0.14rem;
          }
          a{
            color: #2ada78;
            font-size: 0.16rem;
            margin-top: 0.1rem;
          }
        }
      }
      .slogan {
        padding: 0.09rem;
        border: 1px solid #2dd97a;
        font-size: 0.18rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #2dd97a;
        position: absolute;
        left: 50%;
        bottom: 0.5rem;
        transform: translateX(-50%);
        width: fit-content;
      }
    }
  }
  .slogan-tip {
    position: absolute;
    bottom: 0.1rem;
    font-size: 0.12rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    width: 100%;
    text-align: center;
  }
}
</style>